// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"453":"8ab44547","561":"fb21a5a4","738":"2e5e1d42","747":"c4adab9b","748":"cce4b24d","829":"f1c7433d","931":"2931f7c0"}[chunkId] + ".chunk.js";
};